import ApiService from "@/common/api.service";

export default {
  // 與上面用法相同，只是呼叫後端 API 而不是直接 call (這樣可避免 SSL 時不能 call 的問題)
  getGeoLocation() {
    return ApiService.get("ip-geo");
  }
};
